export const MiscActivityCategory = {
    General: 0,
    Drafting: 1,
    CustomerNote: 2,
    SeekAdvice: 3,
};